/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Ladda from 'ladda';
import { View } from 'backbone.marionette';

import OrderTypes from '@/enums/OrderTypes';
import lazyLoadView from '@/util/lazyLoadView';

import loadOrderPackageDeliveryScheduleGridView from '../../loaders/OrderPackageDeliveryScheduleGridViewLoader';
import loadOrderPackageRelocationDeliveryScheduleGridView from '../../loaders/OrderPackageRelocationDeliveryScheduleGridViewLoader';

import tmplOrderPackageDeliveryScheduleView from './OrderPackageDeliveryScheduleView.hbs';

const OrderPackageDeliveryScheduleView = View.extend({
  template: tmplOrderPackageDeliveryScheduleView,

  className: 'order-package-delivery-schedule-view',

  ui: {
    deliveryScheduleGridView: '.delivery-schedule-grid',
    btnDownloadCSV: '.btn-download-csv'
  },

  regions: {
    deliveryScheduleGridView: '@ui.deliveryScheduleGridView'
  },

  events: {
    'click @ui.btnDownloadCSV': 'onClickDownloadCSV'
  },

  templateContext() {
    return {
      isRelocation: this.options?.orderPackage?.orderFormTypeID === OrderTypes.RELOCATION
    };
  },

  onRender() {
    const orderPackageID = this.options.orderPackageID;
    const editable = this.options.editable;
    const orderPackage = this.options.orderPackage;

    const loader =
      orderPackage.orderFormTypeID === OrderTypes.RELOCATION
        ? loadOrderPackageRelocationDeliveryScheduleGridView
        : loadOrderPackageDeliveryScheduleGridView;
    this.deliveryScheduleGridView = lazyLoadView(() => loader({ orderPackageID, editable, orderPackage }));
    this.showChildView('deliveryScheduleGridView', this.deliveryScheduleGridView);
  },

  async onClickDownloadCSV(e) {
    e.preventDefault();
    const spinner = Ladda.create(this.ui.btnDownloadCSV[0]);
    spinner.start();
    await this.deliveryScheduleGridView.call('generateAndDownloadCSV');
    spinner.stop();
  }
});

export default OrderPackageDeliveryScheduleView;
